import { render } from "./HeaderNews.vue?vue&type=template&id=7bb2f6a2&scoped=true"
import script from "./HeaderNews.vue?vue&type=script&lang=js"
export * from "./HeaderNews.vue?vue&type=script&lang=js"

import "./HeaderNews.vue?vue&type=style&index=0&id=7bb2f6a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb2f6a2"]])

export default __exports__